// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1pKzv","alert":"SettungsInbox_alert__3g-wY"};